import React from 'react';
import CSVReader from 'react-csv-reader';

const CSVInput = ({ setLoadFile, skipLines = 0 }) => {
	const papaparseOptions = {
		header: true,
		dynamicTyping: true,
		skipEmptyLines: true,
		transformHeader: (header) => header.toLowerCase().replace(/\W/g, '_'),
		beforeFirstChunk: (chunk) => {
			const lines = chunk.split('\n');
			return lines.slice(skipLines).join('\n');
		},
	};

	return (
		<CSVReader
			cssClass='csv-reader-input'
			onFileLoaded={(data, fileInfo, originalFile) => setLoadFile(data)}
			parserOptions={papaparseOptions}
			inputStyle={{ color: 'red' }}
		/>
	);
};

export default CSVInput;
